module.exports = __webpack_public_path__ + "static/media/prize-decor.3fa8e7df.png";